import ApiClient from '@/libs/http-client'

const PositionsService = {
    endpoints(route, param) {
        const url = {
            positions: '/api/positions',
            changePosition: `/api/positions/${param}`,
        }
        return url[route]
    },
    get(url, param = {}) {
        return ApiClient.get(this.endpoints(url, param))
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config)
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config)
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config)
    },
}

export default PositionsService
